export const TOST_MESSAGE = {
  EMAIL_NOT_VALID: 'Email Is Not Valid',
  OTP_VALIDATION: 'Please Enter OTP',
  NAME_MESSAGE: 'Please Enter Name',
  NOT_DEPARTMENT: 'Not available Department Data',
  NOT_DELETE_DEPARTMENT: 'Department not found. Please try after sometime',
  LOGIN_FAILED: 'Invalid email or password. Please try again.',
  LOGIN_SERVER_ERROR: 'Unable to sign in right now. Please try again later.'
};

export const TOAST_TYPE = {
  TOAST_SUCCESS: 'success',
  TOAST_ERROR: 'error'
};

export const ERROR_MESSAGE = {
  ID_NOT_FOUND: 'id not found'
};
